import React from 'react';
import {
    Grid,
    Container,
    Typography
} from "@material-ui/core";
import Skeleton from '@material-ui/lab/Skeleton';
import { withTranslation } from 'react-i18next';

class Home extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
        };
    }

    render() {

        let title = this.props.userInfo ? this.props.t("welcome") + ": " + this.props.userInfo.firstName : ""
        return (
            <Container className="home-title-position">
                <Grid container direction="row" justifyContent="center" alignItems="center">
                    <Grid item container direction="column" xs={12} sm={12} md={4} lg={4} xl={4} style={{ textAlign: 'center' }}>
                        <Skeleton animation="pulse" />
                        <Typography variant="h4"> {title}</Typography>
                        <Skeleton animation="pulse" />
                    </Grid>
                </Grid>
            </Container>
        );
    }
}

export default withTranslation()(Home);
